"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.luckBasedWin = void 0;
const luckBasedWin_1 = require("../../enums/game/luckBasedWin");
const Alignment_1 = require("../../enums/Alignment");
const Position_1 = require("../../enums/Position");
exports.luckBasedWin = {
    isEnable: false,
    scoreConditionType: luckBasedWin_1.GameLuckBasedScoreConditionType.NO_REQUIREMENT,
    targetScore: 0,
    prePlayedText: 'Play to have the chance to win a Reward',
    prePlayedTextStyle: {
        backgroundColor: 'ffffff',
        fontSize: '20px',
        color: '000000',
        position: Position_1.Position.STATIC,
        top: '56%',
        textAlign: Alignment_1.Alignment.CENTER,
    },
    rewardType: luckBasedWin_1.GameLuckBasedWinRewardType.COUPON_CODE_GENERAL,
    chancesToWinMinValue: 0,
    chancesToWinMaxValue: 100,
    rewardLimit: null,
    rewardLimitType: luckBasedWin_1.GameLuckBasedRewardLimitType.TOTAL,
    rewardValue: 'CODE',
    rewardValueUrl: 'https://www.flarie.com',
    winnersText: 'Congratulations! You were lucky and have won a Reward. Click here to view your Reward',
    winnersTextStyle: {
        backgroundColor: 'ffffff',
        fontSize: '20px',
        color: '000000',
        position: Position_1.Position.STATIC,
        top: '56%',
    },
    popupType: luckBasedWin_1.GameLuckBasedPopUpType.REWARD_IN_GAME,
    popupWinnerText: 'Congratulations! Here is your Reward:',
    popupWinnerStyle: {
        backgroundColor: 'ffffff',
        fontSize: '16px',
        color: '629BF4',
        borderRadius: '12px',
        textAlign: Alignment_1.Alignment.CENTER,
    },
    popupWinnerIconUrl: 'https://prod-cdn.flarie.com/asset/studio/images/settings/winner-star-icon.png',
    popupLooserText: "You didn't win. Better luck next time!",
    popupLooserStyle: {
        backgroundColor: 'ffffff',
        fontSize: '16px',
        color: '629BF4',
        borderRadius: '12px',
        textAlign: Alignment_1.Alignment.CENTER,
    },
    popupLooserIconUrl: 'https://prod-cdn.flarie.com/asset/studio/images/settings/loser-dislike-icon.png',
    couponCodeStyle: {
        backgroundColor: 'ffffff',
        fontSize: '20px',
        color: '629BF4',
        borderRadius: '0px',
    },
    destinationButtonText: 'GO TO OUR WEBSITE',
    destinationButtonStyle: {
        backgroundColor: '629BF4',
        fontSize: '20px',
        color: 'ffffff',
        borderRadius: '20px',
    },
    isEmailDistribution: false,
    numberOfCoupon: 0,
    isIpBlockDeactivated: false,
};
